<template>
  <b-card
    :id="`connector-${index + 1}`"
    no-body
    class="card-table"
  >
    <div
      class="logo__wrapper"
      @click="() => onConnectorClick(item)"
    >
      <b-img :src="`/assets/connectorImages/${image}`" />
    </div>
    <b-tooltip
      v-if="isTooltipVisible"
      :target="item.connectorInstanceName"
      :title="item.connectorInstanceName"
    />
    <b-card-title
      :id="item.connectorInstanceName"
      :ref="item.connectorInstanceName"
    >
      {{ item.connectorInstanceName }}
    </b-card-title>
    <div class="actions__wrapper">
      <b-button
        :id="`connector-${index + 1}-edit`"
        variant="outline-primary"
        size="sm"
        @click="onEditClick"
      >
        <font-awesome-icon :icon="['fas','pencil-alt']" />
        Edit
      </b-button>
      <b-button
        :id="`connector-${index + 1}-delete`"
        variant="outline-danger"
        size="sm"
        @click="onDeleteClick"
      >
        <font-awesome-icon :icon="['fas','trash']" />
        Delete
      </b-button>
    </div>
  </b-card>
</template>

<script>
import {createNamespacedHelpers} from 'vuex';
const {mapState, mapActions} = createNamespacedHelpers('connectorScreen');

export default {
  name: 'ConnectorCardNew',
  props: {
    item: {
      type: Object,
      required: true,
    },
    index: Number,
  },
  data() {
    return {
      isTooltipVisible: false,
    };
  },
  computed: {
    image() {
      return this.item.connectorType === 'dynamo' ? 'Dynamo-logo.png' :'salesforce.svg';
    },
  },
  methods: {
    ...mapActions(['setConnectorData']),
    onEditClick() {
      this.$emit('on-edit-click', this.item);
    },
    onDeleteClick() {
      this.$emit('on-delete-click', this.item);
    },
    onConnectorClick(item) {
      if(item.connectorType === 'dynamo') {
        this.$router.push({
          name: 'dynamo-connector',
          params: {
            configurationId: this.item.connectorInstanceId,
          },
        });
      } else {
        this.setConnectorData(item);
        this.$router.push({
          name: 'connector-salesforce-new',
          params: {
            configurationId: this.item.connectorInstanceId,
          },
        });
      }
    },
  },
  mounted() {
    const $item = this.$refs[this.item.connectorInstanceName];
    this.isTooltipVisible = $item && ($item.scrollWidth > $item.offsetWidth);
  },
};
</script>

<style lang="scss" scoped>
.header-title {
  font-weight: bold;
}

.card-table {
  border-radius: 0;
  height: 180px;
  padding: 15px;
  cursor: pointer;
  display: grid;
  grid-template-rows: 1fr 1fr 1fr;
  row-gap: 5px;
  transition: 0.4s;

  &:hover {
    box-shadow: 0 0 0 2px #19407b;
  }

  .card-title {
    margin-bottom: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}

.actions__wrapper {
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
  gap: 5px;
}

.logo__wrapper {
  height: 80px;
  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
}

</style>
